import { type CrmEvent } from '../events';

import { useGTM } from '@/shared/providers/gtm.provider';

const crmEventToGtmEvent = (event: CrmEvent) => {
  const { name, ...payload } = event;
  return {
    event: name,
    payload,
  };
};

export const useCRM = () => {
  /* TODO: use gtm should eventually be part of this */
  const gtm = useGTM();
  const sendEvent = (event: CrmEvent) => {
    gtm.dataLayer.push(crmEventToGtmEvent(event));
  };

  return { sendEvent };
};
